<nav
  [ngClass]="[
    'horizontal-menu-container-base',
    horizontalMenuContainerCssClass(),
  ]">
  <ul
    [ngClass]="[
      'horizontal-menu-content-base',
      horizontalMenuContentCssClass(),
    ]">
    @for (item of menuItems(); track item.handle) {
      <store-horizontal-menu-item
        [handle]="item.handle"
        [isRootNode]="true"
        [itemCssClass]="menuItemCssClass()">
      </store-horizontal-menu-item>
    }
  </ul>
</nav>
